import React from 'react'
import Radium from 'radium'

import changes from '../../changelog'

const style = {
	list: {
		paddingLeft: 0,
		listStyle: 'none',
		display: 'flex',
		flexDirection: 'column',
	},
	log: {
		borderBottom: '1px solid #1b3253',
		paddingBottom: '1em',

		heading: {
			fontSize: '1.25em',
		},
		date: {
			fontSize: '0.75em',
			color: '#999',
			fontStyle: 'italic',
			marginLeft: '1em',
			fontWeight: 'normal',
		},
	},
}

const ChangeLog = () => {
	const changeLog = changes
		.sort((a, b) => new Date(b.release) - new Date(a.release))
		.map(log => (
			<li key={log.release} id={log.release} style={[style.log]}>
				<h2 style={style.log.heading}>
					{log.name}
					<span style={style.log.date}>{log.release}</span>
				</h2>
				<div dangerouslySetInnerHTML={{ __html: log.__content }} />
			</li>
		))

	return <ul style={[style.list]}>{changeLog}</ul>
}

export default Radium(ChangeLog)



// WEBPACK FOOTER //
// ./src/components/changelog/Log.js